import Environment from '@di-shared/features/environment/Environment';
import Kr from '@di-shared/features/history/download/DatePickerBottomSheet/.kr';
import Eu from '@di-shared/features/history/download/DatePickerBottomSheet/.eu';

export interface DatePickerBottomSheetData {
  selectedDate: Date;
  minDate: Date;
  maxDate: Date;
}

export default function DatePickerBottomSheet() {
  return (
    <>
      <Environment.Kr>
        <Kr />
      </Environment.Kr>
      <Environment.Eu>
        <Eu />
      </Environment.Eu>
    </>
  );
}
